module.exports = __webpack_public_path__ + "img/topicPersonalCare.a044b33c.svg";